import React from "react"
import styles from "./styles.scss"
import image from "images/office.jpg"
import { Parallax, Background } from "react-parallax"

const SaitsImage = () => (
  <section className={styles.container}>
    <Parallax strength={200} className={styles.parallax}>
      <Background className={styles.background}>
        <img
          src={image}
          className={styles.image}
          alt="Två av SAITS erfarna utvecklare på kontoret i Uppsala."
        />
      </Background>
    </Parallax>
  </section>
)

export default SaitsImage



// WEBPACK FOOTER //
// ./src/pages/LandingPage/SaitsImage/index.jsx